<template>
  <div class="tab-container">
    <template v-if="isWindowOpen">
      <div align="center" style="margin:262px 0px 0px 0px">
        <h3 >点击按钮再次打开页面</h3>
        <el-button @click="open()" class="" type="primary" size="medium" :title="href_token"
                   style="margin:0 auto;background-color: #EAEEF2;color: #353535;border-color: #EAEEF2">
          打开页面
        </el-button>
      </div>
    </template>
    <!--<template v-if="reporAlias">
      <templateReport :alias="reporAlias"></templateReport>
    </template>-->
    <template v-else>
      <iframe  style="height:100%;width:100%;border:0px" :src="href_token" >
      </iframe>
    </template>
  </div>
</template>

<script>
import templateReport from '@/components/dataTemplate/templateReport.vue'
let Base64 = require("js-base64").Base64;
export default {
  name: "templateHref",
  components: {templateReport},
  props:["alias","href"],
  data() {
    return {
      href_token:"",//url菜单地址,
      reporAlias:"",//报表地址
      isWindowOpen:false//是否有打开菜单按钮
    };
  },
  watch: {
    href: {
      handler(newVal) {
        this.isWindowOpen=false;
        if(newVal){
          if(newVal.indexOf("${fvue}")!=-1){
              this.href_token=newVal.replace("${fvue}",window.context.front);
          }else if(newVal.indexOf("https")!=0&&newVal.indexOf("http")!=0 && newVal.indexOf("${manageLocation}") == -1){
              this.href_token=newVal;
              this.reporAlias=newVal;
              this.isWindowOpen=true;
          }else{
             if (newVal.indexOf("${authToken}") != -1){
              this.href_token=newVal.replace("${authToken}",Base64.encode(this.$store.state.login.currentUser.account));
               this.isWindowOpen=true;
               this.open();
            }else if (newVal.indexOf("?token=") == -1) {
               this.href_token = newVal+"?token=" + this.$store.state.login.currentUser.token;
             }
             else {
              this.href_token = newVal;
            }
          }
          if(this.href_token.indexOf("sysModulePreview") != -1 ||this.reporAlias ){
            this.isWindowOpen=true;
            this.open();
          }
          if(this.href_token.indexOf("${manageLocation}" != -1)){
            this.href_token = this.href_token.replace("${manageLocation}",window.context.manage);
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    //this.open();
  },
  methods: {
    open() {
      if(this.reporAlias){
        let newPath = this.$router.resolve({
          name:'templateReport',
          params:{
            "alias":this.reporAlias
          }
        })
        window.open(newPath.href,"_blank");
      }else{
        window.open(this.href_token, "_blank");
      }
    }
  }
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     let Base64 = require("js-base64").Base64;
  //     if (vm.href && vm.href.indexOf("?token=") == -1) {
  //       vm.href = Base64.decode(vm.$route.query.href)+"?token=" + vm.$store.state.login.currentUser.token;
  //     } else {
  //       vm.href = Base64.decode(vm.$route.query.href);
  //     }
  //   })
  // },
  // beforeRouteUpdate(to, from, next) {
  //   next();
  //   const vm =this;
  //   let Base64 = require("js-base64").Base64;
  //   if (vm.href && vm.href.indexOf("?token=") == -1) {
  //     vm.href = Base64.decode(vm.$route.query.href)+"?token=" + vm.$store.state.login.currentUser.token;
  //   } else {
  //     vm.href = Base64.decode(vm.$route.query.href);
  //   }
  // }
};
</script>

<style lang="scss" scoped>
.tab-container {
  height: 100%;
  background-color: #fff;
  align-items:center;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
}
.tab-container h3{
  color: #DBD8D4;
  font-size: 18px;
}
</style>
